(() => {
  if (window.FAFooterMobileToggleInitialized) return;
  window.FAFooterMobileToggleInitialized = true;

  const triggerSelector = '.fa-live-footer [data-toggle-column-footer]';
  const mobileMax = 1023;

  document.documentElement.classList.add('fa-footer-toggle-ready');

  const directPanel = (column) => {
    if (!column) return null;
    return Array.from(column.children).find((child) => child.classList.contains('child-column')) || null;
  };

  const setExpanded = (trigger, expanded) => {
    const column = trigger.closest('[data-column]');
    const panel = directPanel(column);
    if (!panel) return;

    trigger.setAttribute('aria-expanded', String(expanded));
    trigger.classList.toggle('active', expanded);
    panel.classList.toggle('active', expanded);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (!trigger || window.innerWidth > mobileMax) return;

    event.preventDefault();
    const footer = trigger.closest('.fa-live-footer');
    const nextExpanded = trigger.getAttribute('aria-expanded') !== 'true';

    if (nextExpanded && footer) {
      footer.querySelectorAll('[data-toggle-column-footer][aria-expanded="true"]').forEach((other) => {
        if (other !== trigger) setExpanded(other, false);
      });
    }

    setExpanded(trigger, nextExpanded);
  });
})();
